import {useCallback} from 'react';
import {useSelector} from 'react-redux';

import {getAccountStatuses} from 'src/openapi/admin/apis/GetAccountStatusesApi';
import {useAppDispatch} from 'src/store/hooks';

import {selectAccountStatuses} from './services/dictionary-slice';

import type {DictionaryItem} from 'src/openapi/admin/models/DictionaryItem';

export const useAccountStatuses = () => {
    const apiDispatch = useAppDispatch();
    const accountStatuses = useSelector(selectAccountStatuses);

    const loadAccountStatuses = useCallback(() => {
        if (!accountStatuses.length) {
            apiDispatch(getAccountStatuses());
        }
    }, [accountStatuses.length, apiDispatch]);

    const getAccountStatusByCode = useCallback((code: string): DictionaryItem | undefined => {
        return accountStatuses?.find(e => e.code === code);
    }, [accountStatuses]);

    return {accountStatuses, loadAccountStatuses, getAccountStatusByCode};
};
